module.exports = __webpack_public_path__ + "img/strenth+1.8b2861f6.webp";